import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Box, Paper } from "@mui/material";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(3, 0),
    maxWidth: 1156,
    [theme.breakpoints.down("md")]: {
      margin: theme.spacing(4, 0),
      paddingBottom: theme.spacing(3)
    }
  },
  selected: {
    border: `solid 1px ${theme.palette.primary.main}`
  }
}));

function SettingsOption(props) {
  const classes = useStyles();
  const { children, highlighted } = props;
  return (
    <Paper
      classes={{ root: classes.container }}
      className={clsx({
        [classes.selected]: highlighted
      })}
    >
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "stretch", md: "center" }}
        overflow="hidden"
      >
        {children}
      </Box>
    </Paper>
  );
}

export default SettingsOption;
